import { motion, useScroll, useSpring } from "framer-motion";

/** Slim glowing scroll-progress bar pinned to the very top of the viewport. */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 28,
    restDelta: 0.001,
  });

  return (
    <motion.div
      data-testid="scroll-progress-bar"
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 h-[3px] origin-left z-[60] bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 shadow-[0_0_14px_rgba(10,132,255,0.85)]"
    />
  );
}
